<template>
  <div style="width: 100%; margin-bottom: 15px">
    <div class="group-header">
      <div class="group-header-text">
        {{ group.name }}
        <span v-if="group.file" @click="getFile(group.id)" class="group-file-name">
          {{ 'File' | i18n }}: {{ group.file }}
          <BIconEye />
        </span>
      </div>
      <div>
        <div class="group-header-confirmation" v-if="enableConfirmation && group.isConfirmation">
          <Checkbox
            :value="confirmationValues[group.id].remoteSupport"
            :form-group-id="`${group.id}-project`"
            :disabled="!hasAccessToProject"
            :input="(v) => setConfirmationValue(group.id, v)"
            :placeholder="'Remote Support' | i18n"
            :left="10"
            :viewMode="viewMode"
          />
          <Checkbox
            :value="confirmationValues[group.id].onSiteSupport"
            :form-group-id="`${group.id}-external`"
            :disabled="!hasAccessToExternal"
            :input="(v) => setConfirmationValue(group.id, v)"
            :placeholder="'On Site' | i18n"
            :left="10"
            :viewMode="viewMode"
          />
        </div>
        <div class="exclude-group" v-if="excludeFromPDFValues">
          <Trigger
            :value="excludeFromPDFValues[group.id]"
            :form-group-id="`${group.id}-excludeFromPDF`"
            :placeholder="`Deactivate Group - will not be shown in PDF report` | i18n"
            :input="(v) => setExcludeFromPDFValue(group.id, v)"
            :bottom="0"
            :viewMode="viewMode"
          />
        </div>
      </div>
    </div>
    <div class="fields-block row">
      <!-- class="row field-container" -->
      <div
        v-for="(field, index) in groupFields"
        :key="`field-${field.id}`"
        :style="index === groupFields.length - 1 ? 'border:none' : ''"
        :class="`col-lg-${field.colomns} col-sm-${field.colomns} col-xs-${field.colomns} ${
          field.entryType === ENTRY_TYPES.EMPTY_SPACE ? 'empty-space-field' : ''
        }`"
      >
        <div
          v-if="!invisibleFields.includes(field.entryType)"
          :ref="`wrapperCanvasRef_${field.id}`"
          :class="`input-wrapper ${fullWidth.includes(field.entryType) ? 'input-block-full-width' : ''}`"
        >
          <div class="input-block">
            <Inputs
              :value="fieldsValue[field.key] || field.defaultValue"
              :textInputValue="fieldsTextInputValue ? fieldsTextInputValue[field.key] || '' : null"
              :field="field"
              :value-for-required-rules="
                field.rules.find(({ name }) => name === VALIDATION_RULES.REQUIRED_WHEN) &&
                fieldsValue[field.rules.find(({ name }) => name === VALIDATION_RULES.REQUIRED_WHEN).referenceField]
              "
              :on-change="(v) => setFieldValue(field, v)"
              :onChangeTextInput="(v) => setFieldTextInputValue(field, v)"
              :lists="lists"
              :getFileURL="getFileURL"
              :getFile="getFile"
              :feeds="feeds"
              :translateLanguage="translateLanguage"
              :enableTranslation="enableTranslation"
              :showValidation="showValidation"
              :setScreenshotData="setScreenshotData"
              :isSignatureDisable="isSignatureDisable"
              :viewMode="viewMode"
            />
            <span v-if="field.file" style="cursor: pointer; z-index: 2; position: relative; word-break: break-all" @click="getFile(field.id)">
              {{ 'File' | i18n }}: {{ field.file }}
              <BIconEye />
            </span>
            <div v-if="field.rules.find(({ name }) => name === 'isAttachFileToEmail')" class="w-100">
              <Checkbox
                :value="field.isAttachFileToEmail"
                :form-group-id="`${field.key}-attach-to-email`"
                :placeholder="$translate('attach_field_to_email', { title: field.title })"
                :left="0"
                :input="(v) => setFieldValue({ key: `${field.key}_attachToEmail`, id: `${field.key}_attachToEmail` }, v)"
                :viewMode="viewMode"
              />
            </div>
          </div>
          <div
            v-if="enableConfirmation && field.isConfirmation"
            :class="`input-confirmation ${fullWidth.includes(field.entryType) ? 'input-confirmation-full-width' : ''}`"
          >
            <Checkbox
              :value="confirmationValues[field.key].remoteSupport"
              :form-group-id="`${field.key}-project`"
              :disabled="!hasAccessToProject"
              :input="(v) => setConfirmationValue(field.key, v)"
              :placeholder="'Remote Support' | i18n"
              :left="10"
              :viewMode="viewMode"
            />
            <Checkbox
              :value="confirmationValues[field.key].onSiteSupport"
              :form-group-id="`${field.key}-external`"
              :disabled="!hasAccessToExternal"
              :input="(v) => setConfirmationValue(field.key, v)"
              :placeholder="'On Site' | i18n"
              :left="10"
              :viewMode="viewMode"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BIconEye } from 'bootstrap-vue';

import { ENTRY_TYPES, VALIDATION_RULES, NO_EDIT_BY_MOBILE, SIZE_IN_PDF } from '../../../../../../../../constants';

import icons from '../../../form-template/upsert-templates/base/icons';

import Inputs from './inputs';
import Checkbox from '../../../common/checkbox';
import Trigger from '../../../common/trigger';

export default {
  name: 'TemplateFields',
  components: {
    Inputs,
    BIconEye,
    Checkbox,
    Trigger,
  },
  props: {
    getFile: {
      type: Function,
      default: () => {},
    },
    groupName: {
      type: String,
      default: 'Group',
    },
    getFileURL: {
      type: Function,
      default: () => {},
    },
    group: {
      type: Object,
      default: () => {},
    },
    feeds: {
      type: Object,
      default: () => {},
    },
    lists: {
      type: Array,
      default: () => [],
    },
    setFieldValue: {
      type: Function,
      default: () => {},
    },
    setFieldTextInputValue: {
      type: Function,
      default: () => {},
    },
    setConfirmationValue: {
      type: Function,
      default: () => {},
    },
    setExcludeFromPDFValue: {
      type: Function,
      default: () => {},
    },
    fieldsValue: {
      type: Object,
      default: () => {},
    },
    fieldsTextInputValue: {
      type: Object,
      default: () => {},
    },
    excludeFromPDFValues: {
      type: Object,
      default: () => {},
    },
    confirmationValues: {
      type: Object,
      default: () => {},
    },
    enableConfirmation: {
      type: Boolean,
      default: false,
    },
    enableTranslation: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    hasAccessToProject: {
      type: Boolean,
      default: false,
    },
    showValidation: {
      type: Boolean,
      default: false,
    },
    hasAccessToExternal: {
      type: Boolean,
      default: false,
    },
    translateLanguage: {
      type: String,
      default: null,
    },
    setScreenshotData: {
      type: Function,
      default: () => {},
    },
    isSignatureDisable: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      VALIDATION_RULES: VALIDATION_RULES,
      icons: icons,
      noEditByMobile: NO_EDIT_BY_MOBILE,
      fullWidth: [ENTRY_TYPES.DRAWING, ENTRY_TYPES.LIST, ENTRY_TYPES.TEXT_BLOCK, ENTRY_TYPES.FEED],
      typesOptions: Object.keys(ENTRY_TYPES).map((item) => ({
        value: ENTRY_TYPES[item],
        text: this.$translate(`ENTRY_${item}`),
      })),
      groupFields: this.group.fields,
      attachingFileToEmail: [ENTRY_TYPES.PHOTO, ENTRY_TYPES.FILE, ENTRY_TYPES.DRAWING, ENTRY_TYPES.PICTURE_IN_TEMPLATE, ENTRY_TYPES.PDF_ATTACHMENT],
      invisibleFields: [ENTRY_TYPES.PAGE_BREAK],
      ENTRY_TYPES,
    };
  },
  watch: {
    group: {
      async handler() {
        this.updateGroupFields();
      },
    },
  },
  created() {
    this.updateGroupFields();
  },
  methods: {
    updateGroupFields() {
      if (this.group.fields) {
        this.groupFields = this.group.fields.map((field) => {
          const currentField = field;
          if (currentField.rules) {
            const r = currentField.rules.find((i) => i.name === VALIDATION_RULES.SIZE_IN_PDF) || {};

            const TEXT_FILEDS = [
              ENTRY_TYPES.TEXT,
              ENTRY_TYPES.INT,
              ENTRY_TYPES.DECIMAL,
              ENTRY_TYPES.BAR_CODE,
              ENTRY_TYPES.DROPDOWN,
              ENTRY_TYPES.DATE,
            ];

            const columnSize = {
              1: 100,
              2: 50,
            };

            const defaultSize = columnSize[SIZE_IN_PDF[currentField.entryType]];
            const v = Number(r.value) || defaultSize;
            if (TEXT_FILEDS.includes(currentField.entryType)) {
              currentField.sizeInPDF = v || (currentField.showTextInput ? 100 : 50);
            } else {
              currentField.sizeInPDF = v || 100;
            }
            currentField.colomns = this.enableConfirmation ? 12 : 12 * (currentField.sizeInPDF / 100);
          }
          return currentField;
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.drop-field-text {
  display: flex;
  text-align: center;
  justify-content: center;
  width: 100%;
  top: -36px;
  position: absolute;
}

.draggable-container {
  min-height: 100px;
}

.draggable-container span::before {
  content: ' ';
  background: rgba(230, 230, 230, 0.1);
  justify-content: center;
  align-items: center;
  display: flex;
  border: 1px dashed #e6e6e6;
  height: 50px;
}
.draggable-container span:empty::before {
  padding: 30px;
}
.draggable-container span:not(:empty)::before {
  opacity: 0;
  content: '';
}
.field-list-icon {
  width: 50px;
  height: 50px;
}
.field-container {
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  border-bottom: 1px solid #d9d9d9;
  padding-bottom: 25px;
  margin: 10px 0;
  background: white;
}

::v-deep .text-input-group {
  margin-bottom: 0px;
  width: 100%;
}

::v-deep .details-action {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: rgb(34, 129, 254);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 28px;
  margin: 0 10px;
  cursor: pointer;
}
::v-deep .details-action-error {
  background: #dc3545;
}

.icons-block {
  width: 120px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.inputs-block {
  display: flex;
  flex: 3;
  justify-content: space-around;
}

.checkboxs-block {
  display: flex;
  padding-top: 2px;
  flex-wrap: wrap;
}

.group-header {
  background: #fafafa;
  width: 100%;
  min-height: 60px;
  padding-left: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.group-header-text {
  color: #5f5f5f !important;
  font-size: 1.5rem !important;
  font-weight: 300;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
}
.group-header-confirmation {
  display: flex;
  flex: 1;
  align-items: center;
  padding-top: 6px;
  padding-right: 16px;
  justify-content: flex-end;
}

.input-wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.input-block {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 100px;
}
.input-block-full-width {
  flex-direction: column-reverse;
}
.input-confirmation {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding-right: 1px;
  padding-top: 11px;
}

.input-confirmation-full-width {
  width: 100%;
}

.group-header span {
  cursor: pointer;
  font-size: 14px;
  color: black;
}
.fields-block > div {
  min-height: 50px;
  position: relative;
}

.fields-block > .empty-space-field {
  min-height: 108px;
}

.edit-btn {
  font-size: 14px;
  margin-left: 20px;
}

.group-file-name {
  word-break: break-all;
  display: flex;
  align-items: center;
  svg {
    margin-left: 5px;
  }
}

@media (max-width: 600px) {
  .group-header-text {
    min-width: 100%;
  }
}

.exclude-group {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 6px;
  padding-right: 16px;
}
</style>
